export const setCurrentLocale = (locale) => ({
  type: 'SET_CURRENT_LOCALE',
  payload: { locale },
});



// WEBPACK FOOTER //
// ./src/common/intl/actions.js